/**
 * Shared utilities for tool rendering.
 * These utilities are used by both ChatMessage and trip overlay ChatPanel.
 */

import type { MessageRow } from '@/domain/chat/types'
import type { ToolCall, ToolResponse } from '@generated/proto/model'

/**
 * Find a tool response message that corresponds to a tool call by matching toolCallId.
 */
export function findToolResponse(allMessages: MessageRow[], toolCallId: string): ToolResponse | null {
  const responseMessage = allMessages.find(msg =>
    msg.proto.content?.case === 'toolResponse' &&
    msg.proto.content.value?.toolCallId === toolCallId
  )

  if (responseMessage?.proto.content?.case === 'toolResponse' && responseMessage.proto.content.value) {
    return responseMessage.proto.content.value
  }

  return null
}

/**
 * Format copy text for tool call clipboard.
 * Includes tool name, arguments, and response (if available).
 */
export function formatToolCopyText(toolCall: ToolCall, toolResponse: ToolResponse | null): string {
  let text = `Tool Call: ${toolCall.toolName}\nArguments: ${toolCall.arguments || 'none'}`
  if (toolResponse) {
    const responseContent = toolResponse.content || ''
    const responseError = toolResponse.error || ''
    text += `\n\nResponse: ${responseError || responseContent}`
  }
  return text
}
